var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_vm.showMessageIcon ? _c("a", {
    staticClass: "notif",
    on: {
      click: _vm.goToNotificationCenter
    }
  }, [_c("i", {
    staticClass: "el-icon-bell"
  }), _vm.unreadMessages ? _c("div", {
    staticClass: "unread"
  }, [_vm._v(" " + _vm._s(_vm.unreadMessages) + " ")]) : _vm._e()]) : _vm._e()]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };